import * as React from 'react'

export enum ResourceItemVariants {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6',
    default = 'div',
}

export enum ResourceItemType {
    Application = 'application',
    Container = 'container',
    Environment = 'environment',
    Secret = 'secret',
    Label = 'label', 
    Link = 'link',
    ChangeRequest = 'changerequest'
}

const ResourceItemTypeIcon = {
    [ResourceItemType.Application]: 'A',
    [ResourceItemType.Container]: 'C',
    [ResourceItemType.Environment]: 'E',
    [ResourceItemType.Secret]: 'S',
    [ResourceItemType.Label]: 'L', 
    [ResourceItemType.Link]: 'L',
    [ResourceItemType.ChangeRequest]: 'CR'
};

interface ResourceNameProps {
    variant?: ResourceItemVariants
    type: ResourceItemType
    children: React.ReactNode
}

const ResourceItem: React.FunctionComponent<ResourceNameProps> = ({ type, variant, children }) => {
    const Component: any = variant ? variant : ResourceItemVariants.default;
    const Icon = ResourceItemTypeIcon[type]
    const classes = variant ? 'pf-v5-c-title pf-m-2xl' : ''

    return (
            <Component className={classes}>
                <div className='co-resource-item'>
                    <span className={`
                        co-resource-icon
                        co-resource-icon--${type}`
                    }>
                        {Icon}
                    </span>{children}
                </div>
            </Component>
    )
}

export { ResourceItem }